import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Chip, chipClasses, styled } from "@mui/material";
import FieldDto from "../../../../Types/Api/DTO/FieldDto";
const CustomAddChip = styled(Chip)(({ theme }) => ({
  [`& .${chipClasses.deleteIcon} : hover`]: {
    color: theme.palette.success.dark,
  },
}));
export default function AddChip({ label, onDelete, model, active }: { label: string; onDelete: any; model: FieldDto; active?: boolean }) {
  return (
    <div onClick={() => onDelete(model)}>
      <CustomAddChip
        sx={{ margin: "8px 4px" }}
        label={label}
        onDelete={() => {}}
        color={active ? "success" : "secondary"}
        deleteIcon={<CheckCircleIcon fontSize="medium" />}
        variant="outlined"
      />
    </div>
  );
}
